import { HttpRequest } from './HttpRequest';
import { baseUrl, userControl, quotationUrl } from 'utils/ApiRoutes';

export const listAllUsers = async (
  onError: (text: string) => void
): Promise<IListAllUsersResponse> => {
  try {
    const users = await new HttpRequest().Get<IListAllUsersResponse>(
      `${baseUrl}${userControl.cognitoUsers}`
    );

    return users.data;
  } catch (err) {
    throw onError('Ha ocurrido un error al listar los usuarios.');
  }
};

export const listAllCotizaciones = async (
  onError: (text: string) => void
): Promise<IUserCotizaciones[]> => {
  try {
    const users = await new HttpRequest().Get<IUserCotizaciones[]>(
      `${baseUrl}${userControl.cotizacionesUsers}`
    );

    return users.data;
  } catch (err) {
    throw onError('Ha ocurrido un error al listar las cotizaciones.');
  }
};

export const listAllExcel = async (
  tipo: string,
  bucketName: string,
  onError: (text: string) => void
): Promise<any> => {
  try {
    const excels = await new HttpRequest().Get<any>(`${baseUrl}/listaArchivos?tipo=${tipo}`);

    return excels.data.listFiles;
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Ha ocurrido un error al listar los Excel.';
    throw onError(errorMessage);
  }
};

export const downloadExcel = async (
  Key: string,
  tipo: string,
  bucketName: string,
  onError: (text: string) => void
): Promise<any> => {
  try {
    const excels = await new HttpRequest().Get<any>(`${baseUrl}/linkDescarga/${Key}?tipo=${tipo}`);

    return excels.data;
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Ha ocurrido un error al descargar el Excel.';
    throw onError(errorMessage);
  }
};

export const statusUser = async (onError: (text: string) => void): Promise<any> => {
  try {
    const email = localStorage.getItem('id_email');
    const users = await new HttpRequest().Get<any>(`${baseUrl}/obtenerUsuario/${email}`);

    return users.data;
  } catch (err) {
    window.location.reload();
    throw onError('Su usuario a sido eliminado.');
  }
};

export const getQuotationResume = async (
  typeQuoteWithId: string
): Promise<IQuotationResumeService> => {
  try {
    const resume = await new HttpRequest().Get<IQuotationResumeService>(
      `${baseUrl}${quotationUrl.quoteResume}${typeQuoteWithId}`
    );
    return resume.data;
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Error al obtener el resumen de la cotización';
    throw new Error(errorMessage);
  }
};
